import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "rubin-items-wrapper",
  class: "relative min-h-full font-light tracking-wider"
}
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }

import AppLoading from "./components/AppLoading.vue";
import DiamondsMain from "@/components/diamonds/diamondsMain.vue";
import CatalogMain from "@/components/catalog/catalogMain.vue";
import FontsRubin from "@/components/fonts/fontsRubin.vue";
import {Config} from "@/assets/ts/config";
import FontsSteinberg from "@/components/fonts/fontsSteinberg.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const getOwnRoute = () => {
  const path = window.location.pathname

  if (Config.getCatalogItemType() !== "") {
    if (Config.getCatalogItemType() === "diamonds") {
      return "diamonds"
    } else {
      return "catalog"
    }
  } else if (Config.getInitialItem() != "") {
    return ""
  } else if (path.includes('/diamonds') || /\/diamonds\/(.*)/.test(path)) {
    return "diamonds"
  } else if (path.includes('/catalog') || /\/catalog\/(.*)/.test(path)) {
    return "catalog"
  }
  return ""
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(Config).getCatalogBrand() === 'R')
      ? (_openBlock(), _createBlock(FontsRubin, { key: 0 }))
      : (_unref(Config).getCatalogBrand() === 'S')
        ? (_openBlock(), _createBlock(FontsSteinberg, { key: 1 }))
        : _createCommentVNode("", true),
    _createVNode(AppLoading),
    (getOwnRoute() === '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_view)
        ]))
      : (getOwnRoute() === 'diamonds')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(DiamondsMain)
          ]))
        : (getOwnRoute() === 'catalog')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(CatalogMain)
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})